// this file is used to replace the module import that should not be included in the bundle
// it is referenced in the webpack config as an alias

const emptyModule = {};
// ts-prune-ignore-next
export default emptyModule;
